import { Component, Inject, NgZone, OnInit } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ToastrService } from 'ngx-toastr';
import { TagsService } from 'src/app/services/tags.service';
import { lastValueFrom } from 'rxjs';
import { CKEditorService } from 'src/app/includes/note-editor/ckeditor.service';
import { PhrasesService } from 'src/app/includes/phrases/phrases.service';
import { AuthService } from 'src/app/services/auth.service';
@Component({
  selector: 'app-add-tags-dialogue',
  templateUrl: './add-tags-dialogue.component.html',
  styleUrls: ['./add-tags-dialogue.component.css']
})
export class AddTagsDialogueComponent implements OnInit {
  isBhAssessmentTool: boolean;
  dueDate: '';
  isICD10: boolean = false;
  newTag = {
    name: '',
    color: '#2bc6b9',
    phrase: '',
    phrase_text: '',
    is_deleted: false
  };

  isCloseDialogue = false;
  isButtonDisable = true;
  dataSource: any = new MatTableDataSource([]);
  displayedColumns: string[] = ['name', 'color', 'phrase', 'phrase_text'];
  tags = [];
  isShowTable = false;
  phrase: string = '';
  cke4Config;
  currentUser: any;
  
  constructor(private toastr: ToastrService, private dialogRef: MatDialogRef<AddTagsDialogueComponent>, private tagsService: TagsService, 
    private phrasesService: PhrasesService, private _authService: AuthService, private ngZone: NgZone,
    @Inject(MAT_DIALOG_DATA) public data: AddTagsDialogueComponent, private ckeditorService: CKEditorService) {
      this.isBhAssessmentTool = data.isBhAssessmentTool;
      this.cke4Config = {
        ...this.ckeditorService.getDefaultConfig(),
        editable: true
      };
      
      const extraPlugins = this.cke4Config.extraPlugins.split(',');
      this.cke4Config.extraPlugins = [...extraPlugins, 'sourcearea', 'phrasesautocomplete', 'selectdropdown'].join(',');

      this.currentUser = this._authService.currentUser;

  
     }

  ngOnInit(): void {
    this.phrasesService.getNoteBuilderDictionary( this.currentUser._id ).subscribe();
    this.initGlobalScope();
  }

  ngOnDestroy() {
    this.ckeditorService.destroyEditorInstance();
    delete window['angularComponentReference'];
  }

  initGlobalScope() {
    window['angularComponentReference'] = {
      component: this, zone: this.ngZone,
      componentDataMembers: {
        componentName: 'add-tags-dialogue',
        phrases: this.phrasesService.castPhrases,
        selectdropdown: {
          disableOptionSelection: () => true
        }
      },

      componentFunctions: {
        filterPhrasesByOptions: this.phrasesService.filterPhrasesByOptions
      }
    };
  }

  checkPhraseText(){
    let phrase_text = this.tagsService.extractContentFromHtmlTag(this.newTag.phrase_text);
    if (phrase_text.trim().length === 0)
      return true;
    return false;  
  }

  async handleSubmit(event: any) {
    let res: any, toastrId: any;
    this.checkIsEmpty();
    try {
      if (!this.isCloseDialogue) {
        let isContainSpace = this.checkPhraseText();

        if (isContainSpace)
          this.newTag.phrase_text = '';
        if (!this.isButtonDisable) {
          this.newTag.phrase = this.newTag.phrase.toLowerCase();
          if (!this.newTag.phrase.startsWith('.')) {
            this.newTag.phrase = '.' + this.newTag.phrase;
          }
          if (!this.newTag.phrase.endsWith('@dn')) {
            this.newTag.phrase = this.newTag.phrase + '@dn'
          }
          toastrId = this.toastr.info("Adding New Tag", "Please Wait...", { disableTimeOut: true });
          const filter = { phrase: this.newTag.phrase, expiryDays: this.dueDate ?? 0, isICD10: this.isICD10 };
          const details = { ...this.newTag, isBhAssessmentTool: this.isBhAssessmentTool };
          res = await lastValueFrom(this.tagsService.createTag(filter, details));
          if (res.status == 200) {
            this.toastr.clear(toastrId);
              this.toastr.success(res.message, "Success");

            this.dialogRef.close({ data: res });
          } else {
            this.toastr.clear(toastrId.toastId);
            res.data[0].extracted_phrase_text = this.tagsService.extractContentFromHtmlTag(res.data[0].phrase_text);
            this.tags = res.data;
            this.dataSource.data = this.tags;
            this.isShowTable = true;
            this.phrase = res.data[0].phrase;
            this.isButtonDisable = true;
            this.toastr.warning(res.message);
          }
        }
      }
      else
        this.dialogRef.close({ data: res });


    } catch (err) {
      this.toastr.clear(toastrId);
      this.toastr.error('Something went wrong', 'Error');
    }
  }

  closeDialog(event?: any) {
    this.isCloseDialogue = true;
    this.dialogRef.close();
  }

  checkIsPhraseExist() {
    this.checkIsEmpty();
    if (this.phrase == this.newTag.phrase)
      this.isButtonDisable = true;
    else
      this.isButtonDisable = false;

  }

  checkIsEmpty() {
    if (this.newTag.name.trim().length === 0)
      this.isButtonDisable = true;
    else
      this.isButtonDisable = false;
  }

  generatePhrase() {
    let prefix = this.isBhAssessmentTool ? '.' : '.tag_';
    let suffix = '@dn';
    this.newTag.name = this.newTag.name.trim();
    this.newTag.name = this.newTag.name.replace(/\s+/g, " ");               // remove extra white spaces in between words
    let words = this.newTag.name.toLowerCase().split(' ');
    let phrase = prefix.concat(words.join("_"));
    this.newTag.phrase = phrase.concat(suffix);

    this.checkIsPhraseExist();
  }

  clearDetails() {
    this.newTag = {
      name: '',
      color: '#2bc6b9',
      phrase: '',
      phrase_text: '',
      is_deleted: false
    };
    this.isButtonDisable = true;
    this.isShowTable = false;
  }


}

